var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.hasSearchParams)?_c('OrderSearch',{attrs:{"view-type":_vm.vt}}):_vm._e(),_c('OrderList',{attrs:{"stage":_vm.stage,"view-type":_vm.vt,"show-button-group":!_vm.hasSearchParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }